// Componente ConfirmDialog - Diálogo de confirmación
// Usa el componente Modal para mostrar confirmaciones elegantes

import Modal from './Modal'
import Button from './Button'
import './ConfirmDialog.css'

/**
 * Componente ConfirmDialog
 * @param {Object} props - Propiedades del componente
 * @param {boolean} props.isOpen - Si el diálogo está abierto
 * @param {Function} props.onClose - Función a ejecutar al cerrar
 * @param {Function} props.onConfirm - Función a ejecutar al confirmar
 * @param {string} props.title - Título del diálogo
 * @param {string} props.message - Mensaje del diálogo
 * @param {string} props.confirmText - Texto del botón de confirmar
 * @param {string} props.cancelText - Texto del botón de cancelar
 * @param {string} props.variant - Variante: 'default', 'danger', 'warning'
 */
function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirmar acción',
  message = '¿Estás seguro de que deseas continuar?',
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  variant = 'default'
}) {
  const handleConfirm = () => {
    onConfirm()
    onClose()
  }

  // Determinar si el message es un string o JSX
  const isStringMessage = typeof message === 'string'

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      variant={variant}
      size={isStringMessage ? "small" : "medium"}
    >
      <div className="confirm-dialog">
        {isStringMessage ? (
          <p className="confirm-message">{message}</p>
        ) : (
          <div className="confirm-message-content">{message}</div>
        )}
        <div className="confirm-actions">
          <Button
            variant="outline"
            onClick={onClose}
          >
            {cancelText}
          </Button>
          <Button
            variant={variant === 'danger' ? 'danger' : 'primary'}
            onClick={handleConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmDialog

